"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardMenuPopper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardMenuPopperMixin = require("../../mixins/components/PropertyCardMenuPopperMixin");
var _MenuPopper = require("../MenuPopper/MenuPopper");
var StyledPropertyCardMenuPopper = /*#__PURE__*/(0, _styledComponents.default)(_MenuPopper.MenuPopper).withConfig({
  displayName: "StyledPropertyCardMenuPopper",
  componentId: "c11n-8-107-0__sc-at0zrq-0"
})(["", ""], _PropertyCardMenuPopperMixin.PropertyCardMenuPopperMixin);
exports.StyledPropertyCardMenuPopper = StyledPropertyCardMenuPopper;